import { Injectable } from '@angular/core';
import { TeacherSubjectView } from '../../../../../models/TeacherSubjectView';

/**
 * Keeps the last loaded statistics overview per subject and group filter. The statistics page lives in a plain
 * router-outlet and is destroyed on leaving, so a re-created page starts from here to show the stale view
 * (STALE_DATA) while it reloads in the background (PRD T07.0).
 */
@Injectable({ providedIn: 'root' })
export class SubjectStatisticsCacheService {
  private readonly views = new Map<string, TeacherSubjectView>();
  private version = 0;

  get sessionVersion(): number {
    return this.version;
  }

  get(subjectId: string, groupId: string | null = null): TeacherSubjectView | null {
    return this.views.get(this.key(subjectId, groupId)) ?? null;
  }

  set(subjectId: string, view: TeacherSubjectView, groupId: string | null = null): void {
    this.views.set(this.key(subjectId, groupId), view);
  }

  clear(): void {
    this.version += 1;
    this.views.clear();
  }

  private key(subjectId: string, groupId: string | null): string {
    return `${subjectId}:${groupId ?? ''}`;
  }
}
